import { create } from 'zustand'
import { persist } from 'zustand/middleware'

export interface CartItem {
  productoId: number
  nombre: string
  emoji: string
  imagenUrl?: string
  precio: number
  cantidad: number
  stockDisponible: number
}

interface CartStore {
  items: CartItem[]
  addItem: (item: Omit<CartItem, 'cantidad'>) => void
  removeItem: (productoId: number) => void
  updateQty: (productoId: number, delta: number) => void
  setQty: (productoId: number, qty: number) => void
  clear: () => void
  total: () => number
  totalItems: () => number
}

export const useCartStore = create<CartStore>()(
  persist(
    (set, get) => ({
      items: [],

      addItem: (item) => set(state => {
        const found = state.items.find(i => i.productoId === item.productoId)
        if (found) {
          if (found.cantidad >= item.stockDisponible) return state
          return { items: state.items.map(i => i.productoId === item.productoId ? { ...i, cantidad: i.cantidad + 1 } : i) }
        }
        return { items: [...state.items, { ...item, cantidad: 1 }] }
      }),

      removeItem: (productoId) => set(state => ({ items: state.items.filter(i => i.productoId !== productoId) })),

      updateQty: (productoId, delta) => set(state => ({
        items: state.items
          .map(i => i.productoId === productoId ? { ...i, cantidad: Math.max(0, Math.min(i.cantidad + delta, i.stockDisponible)) } : i)
          .filter(i => i.cantidad > 0),
      })),

      setQty: (productoId, qty) => set(state => ({
        items: state.items.map(i => i.productoId === productoId ? { ...i, cantidad: Math.max(1, Math.min(qty, i.stockDisponible)) } : i),
      })),

      clear: () => set({ items: [] }),
      total: () => get().items.reduce((sum, i) => sum + i.precio * i.cantidad, 0),
      totalItems: () => get().items.reduce((sum, i) => sum + i.cantidad, 0),
    }),
    { name: 'aqua-cart' }
  )
)
